import ButtonWithOauth from '@components/ButtonWithOAuth'
import useCurrentUser from '@hooks/useCurrentUser'
import { useParams } from 'react-router-dom'

const Canva = () => {
  const currentUserPayload = useCurrentUser()

  const { agencyId: selectedAgencyId } = useParams()

  return (
    <ButtonWithOauth
      authProviderKey="canva"
      buttonStyle="secondaryCreate"
      queryParams={{
        agency_id: selectedAgencyId,
        current_user_id: currentUserPayload.currentUser.id,
        redirect: window.location.href,
      }}
      size="medium"
      // @ts-expect-error
      width="auto"
    >
      Connect with Canva
    </ButtonWithOauth>
  )
}

export default Canva
